import React, { MouseEvent, ReactNode } from 'react';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { Text, TitleFeatured } from '@/components/typography';
import { LayoutInternal } from '@/layout';
import { urlPacotes } from '@/config/url';
import { Grid } from '@/components/grid';
import { usePacotesListContext } from './context/PacotesListContext';
import CardProduct from '@/features/pacote/components/CardProduct/CardProduct';
import { ProductList } from './PacotesList.styles';
import { FilterBar, TravelTypeHeading, TravelTypeMenu } from '@/features/pacote/PacotesList/components';
import CardCurrencyInfo from '@/features/pacote/components/CardCurrencyInfo/CardCurrencyInfo';
import CreateJourney from '@/components/cta/CreateJourney';
import Sticky from '@/components/sticky/Sticky';

export interface PacotesListProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const PacotesList = ({ children, ...props }: PacotesListProps) => {
  const { data } = usePacotesListContext();
  const { destino, pacotes, queryTravelType, travelType } = data;

  const breadcrumbs: BreadcrumbType = [];

  if (queryTravelType && travelType?.id === queryTravelType) {
    breadcrumbs.push({ path: '/viagens', text: 'Viagens' });
    breadcrumbs.push({ path: `/viagens/${travelType.slug}`, text: travelType.title });
    breadcrumbs.push({ text: destino.title || '' });
  } else {
    breadcrumbs.push({ path: urlPacotes(), text: 'Pacotes' });
    breadcrumbs.push({ path: urlPacotes(destino.slug), text: destino.title });
  }

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} cover={destino?.cover}>
      <WhitePaper col={12}>
        <TitleFeatured
          as="h1"
          title={`Pacotes de Viagem ${destino?.title}`}
          description={destino.description_packages}
        />
      </WhitePaper>

      <Grid item col={12} col-sm={12} col-lg={3} as="aside">
        <Sticky top={5} zIndex={10}>
          <TravelTypeMenu />
          {(pacotes.length && <CreateJourney visibility={{ hide: 'sm' }} />) || null}
        </Sticky>
      </Grid>

      <Grid item col={12} col-sm={12} col-lg={9}>
        <WhitePaper>
          <TravelTypeHeading />
          <FilterBar />
          <ProductList>
            {(pacotes.length &&
              pacotes.map((pacote, index) => <CardProduct prefix="Pacote" key={pacote.id} pacote={pacote} />)) || (
              <Text>Não há pacotes para o destino {destino.title} no momento.</Text>
            )}
          </ProductList>
        </WhitePaper>
        <CreateJourney size="large" visibility={{ min: 'sm' }} />
        <CardCurrencyInfo />
      </Grid>
    </LayoutInternal>
  );
};

export default PacotesList;
